export const AM_ORGANIZATIONS_RETRIEVE_REQUESTED = 'AM_ORGANIZATIONS_RETRIEVE_REQUESTED';
export const AM_ORGANIZATIONS_RETRIEVE_SUCCEED = 'AM_ORGANIZATIONS_RETRIEVE_SUCCEED';
export const AM_ORGANIZATIONS_RETRIEVE_FAILED = 'AM_ORGANIZATIONS_RETRIEVE_FAILED';
